export enum ErrorSizeTypes {
    small = "small",
    medium = "medium",
    large = "large"
}